// extracted by mini-css-extract-plugin
export default {"tupacGrid":"Jj-z","tupacHeader":"Kj-z","tupacHeader2":"Lj-z","tupacMenu":"Mj-z","tupacMenu2":"Nj-z","tupacMain":"Oj-z","tupacMain2":"Pj-z"};